import {
  createAxiosInstanceSetAction,
  AXIOS_INSTANCE_SET,
} from "./../actions/axios";
import { AxiosInstance } from "axios";

export interface IAxiosState {
  instance: AxiosInstance | null;
  baseURL: string;
}

export const initialAxiosState: IAxiosState = { instance: null, baseURL: "" };

export const axiosReducer = (
  previousState: IAxiosState = initialAxiosState,
  action: ReturnType<typeof createAxiosInstanceSetAction>
) => {
  switch (action.type) {
    case AXIOS_INSTANCE_SET:
      return {
        ...previousState,
        instance: action.payload.axios,
        baseURL: action.payload.baseURL,
      };
    default:
      return previousState;
  }
};
